import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
  },
  container: ({ orientation }) => ({
    display: 'flex',
    flexDirection: orientation === 'horizontal' ? 'column' : 'row',
    alignItems: 'center',
  }),
  bar: ({ orientation, colors }) => {
    const isH = orientation === 'horizontal';
    const dir = isH ? 'to right' : 'to bottom';
    return {
      width: isH ? 150 : 25,
      height: isH ? 25 : 150,
      background: `linear-gradient(${dir}, ${colors.join(', ')})`,
      border: '1px solid #000',
      marginRight: !isH ? theme.spacing(0.75) : 0,
      marginBottom: isH ? theme.spacing(0.75) : 0,
    };
  },
  labels: ({ orientation }) => ({
    display: 'flex',
    flexDirection: orientation === 'horizontal' ? 'row' : 'column',
    justifyContent: 'space-between',
    width: orientation === 'horizontal' ? 150 : 'auto',
    height: orientation === 'vertical' ? 150 : 'auto',
  }),
  caption: ({ orientation }) => ({
    fontSize: theme.typography.body2.fontSize,
    textAlign: orientation === 'horizontal' ? 'center' : 'left',
  }),
}));

const GradientLegend = ({ colors = [], title = '', labels = [], orientation = 'vertical' }) => {
  const classes = useStyles({ colors, orientation });

  return (
    <Box className={classes.root}>
      {title && (
        <Typography variant="body2" color="textPrimary" gutterBottom>
          {title}
        </Typography>
      )}
      <Box className={classes.container}>
        <Box className={classes.bar} />
        {labels.length > 0 && (
          <Box className={classes.labels}>
            {labels.map((label, i) => (
              <Typography key={i} variant="caption" className={classes.caption}>
                {label}
              </Typography>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

GradientLegend.propTypes = {
  colors: PropTypes.array.isRequired,
  title: PropTypes.string,
  labels: PropTypes.array,
  orientation: PropTypes.oneOf([ 'vertical', 'horizontal' ]),
};


export { GradientLegend };
